import React, { FunctionComponent, useState, useRef, useEffect } from "react";
import styles from "./ProjectVideoModal.module.css";
import { IoMdDocument } from "react-icons/io";
import { connect, useDispatch } from "react-redux";
import Loading from "../../Loading/Loading";
import { themeColors } from "../../theme";
import { motion } from "framer-motion/dist/framer-motion";
import Backdrop from "../../Backdrop/Backdrop";
import { uploadProjectResources } from "../../../Services/resources";
import "../../../theme-vars.css";
import { useMediaQuery, useTheme } from "@mui/material";
import StyledSubmitButton from "../../Buttons/StyledSubmitButton";
import Modal, { Styles } from "react-modal";
import StyledCancelButton from "../../Buttons/StyledCancelButton";

type props = {
  open: boolean;
  close: () => void;
  title: string;
  projectData: any;
  type: string;
  attachmentsList: any[];
  user: any;
  theme: any;
};

// Animation variants for framer-motion
const dropIn = {
  hidden: {
    y: "-100vh",
    opacity: 1,
  },
  visible: {
    y: "0",
    opacity: 1,
    transition: {
      duration: 1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
};

const AttachmentModal: FunctionComponent<props> = ({
  user,
  open,
  close,
  title,
  projectData,
  type,
  attachmentsList,
  theme
}) => {
  const dispatcher = useDispatch();

  /** MUI theme hook for responsive styling */
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));

  // Ref kept in case you want direct DOM access later (not required in current logic)
  const attachmentRef: any = useRef();
  const [load, setLoad] = useState(false);
  const [file, setFile] = useState<any>();

  /**
   * Handles both file selection and drag-and-drop uploads.
   * @param fileList FileList from <input> or DataTransfer
   */
  const upload = async (file: any) => {
    let name: any = document.getElementById('file-input')
    let nameList = name.value.split("\\")

    // Get the first file and its name
    let fileName = nameList[nameList.length - 1]

    // Close modal UI before starting async upload
    close();
    setLoad(true);
    await uploadProjectResources(
      file[0],
      projectData,
      type,
      fileName,
      dispatcher
    );
    setLoad(false);

  };

  /**
  * Theme-responsive table styling
  */
  const tdStyles = {
    backgroundColor: theme ? themeColors.tdBackgroundColor : themeColors.tdBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };

  const thStyles = {
    backgroundColor: theme ? themeColors.thBackgroundColor : themeColors.thBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark
  }

  /**
   * React Modal Styling
   */
  const modalStyle: Styles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1300,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      background: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark,
      color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
      borderRadius: 16,
      padding: isMobile ? "24px 12px" : "10px 20px",
      border: "none",
      boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      margin: "auto",
      inset: "auto",
    },
  };

  return (
    <>
      {load && <Loading />}
      {open && <Modal
        isOpen={open}
        onRequestClose={close}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        style={modalStyle}
        ariaHideApp={false}
      >
        <div className={styles.child}>
          <h5
            style={{
              fontFamily: "var(--font-family-main)",
              fontSize: "var(--font-size-large)",
              paddingTop: isMobile ? "unset" : "15px"
            }}
          >
            {/* Modal Title */}
            {title}
          </h5>

          {/* Drag & Drop Area */}
          <div
            className={styles.dragBox}
            // style={containerStyles}
            onDragOver={(e) => {
              e.preventDefault();
            }}
            onDrop={(e) => {
              e.preventDefault();
              upload(e.dataTransfer.files);
              setLoad(true);
            }}
          >
            <IoMdDocument size={80} color={"#808080"} />
            <p>Drag And Drop</p>
          </div>

          {/* ACTION BUTTONS SECTION */}
          <div className={styles.selectBox}>
            <div style={{ marginRight: 8 }}>
              <StyledCancelButton onClick={close}>Cancel</StyledCancelButton>
            </div>

            {/* FILE UPLOAD BUTTON */}
            <div>
              <input
                id="file-input"
                className={styles.select}
                type="file"
                // Better extensions: allow images + PDF + Word docs
                accept=".png,.jpg,.jpeg,.pdf,.docs"
                onChange={(e) => upload(e.target.files)}
              />
              <StyledSubmitButton
                onClick={() => document.getElementById("file-input")?.click()}
              >
                Upload
              </StyledSubmitButton>
            </div>
          </div>
        </div>
      </Modal>
      }
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode
  };
};

export default connect(mapStateToProps)(AttachmentModal);
